<div class="row">
  <div class="col-12">
    <sb-card [loading]="loading">
      <div card-fit>
        <sb-wizard [hideTabs]="true">
          <sb-wizard-tab titleText="{{ 'lang.wizard.tabs.generalSettings' | translate }}" icon="basicSettings"
                         [active]="true">
            <form [formGroup]="form" class="wizard__forms px-5 pb-5">
              <h3 class="mb-4">{{'lang.globals.relatedCompany' | translate}}</h3>
              <div class="wizard__forms__filterWrapper">
                <div class="wizard__forms__filterWrapper__filterStep">
                  <div
                    [ngClass]="{'wizard__forms__filterWrapper__filterStep__singleFilter--active' : wizardState.startsWith('CompanySelect')}"
                    class="wizard__forms__filterWrapper__filterStep__singleFilter">
                    <div class="wizard__forms__filterWrapper__filterStep__icon">
                      <sb-icon [ngClass]="{'blue' : location?.managedBy}" icon="company"></sb-icon>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__label">
                      <h3 *ngIf="location?.managedBy?.name">{{location?.managedBy?.name}}</h3>
                      <label class="form-label">{{'lang.globals.company' | translate}}</label>
                    </div>
                    <div class="wizard__forms__filterWrapper__filterStep__options">
                      <sb-button (click)="changeWizardState('CompanySelect')"
                                 ngbTooltip="{{'lang.globals.selectCompany' | translate}}"
                                 placement="top" container="body"
                                 classes="btn-hover-primary m-0 green {{wizardState==='CompanySelect' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="list"></sb-icon>
                      </sb-button>
                      <span *ngIf="!location?.id" class="btn-separator">|</span>
                      <sb-button *ngIf="!location?.id" (click)="changeWizardState('CompanyCreate')"
                                 ngbTooltip="{{'lang.companies.createCompany' | translate}}" placement="top"
                                 style="z-index: 10000;" container="body"
                                 classes="btn btn-hover-primary m-0 green {{wizardState==='CompanyCreate' ? 'btn-hover-primary--active' : ''}}">
                        <sb-icon icon="plus"></sb-icon>
                      </sb-button>
                      <span class="btn-separator">|</span>
                      <sb-button *ngIf="location?.managedBy" (click)="sliceCompany()" container="body"
                                 ngbTooltip="{{'lang.globals.removeCompany' | translate}}"
                                 placement="top" classes="btn-hover-primary m-0 red">
                        <sb-icon icon="trash"></sb-icon>
                      </sb-button>
                    </div>
                  </div>
                </div>
              </div>
              <h3 class="my-4">{{'lang.locationEdit.locationDetails' | translate}}</h3>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="Title">{{'lang.globals.name' | translate}}<span class="red">*</span></label>
                    <input type="text" id="Title" class="form-control" formControlName="Name">
                    <span class="form-text text-muted">{{'lang.globals.nameDescription' | translate}}</span>
                    <div *ngIf="Name.touched && Name.errors?.required"
                         class="alert alert-danger">{{'lang.globals.nameWarning' | translate}}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group validateMe">
                    <label class="form-label" for="UniqueIdentifier">{{'lang.globals.uniqueIdentifier' | translate}}</label>
                    <input type="text" id="UniqueIdentifier" class="form-control" formControlName="UniqueIdentifier">
                    <span class="form-text text-muted">{{'lang.globals.uniqueIdentifierDescription' | translate}}</span>
                    <div *ngIf="UniqueIdentifier.touched && UniqueIdentifier.errors?.required"
                         class="alert alert-danger">{{'lang.globals.uniqueIdentifierWarning' | translate}}</div>
                  </div>
                </div>
              </div>
              <hr class="border-dashed">
              <sb-comp-address-component
                *ngIf="!loading && location?.address"
                [point]="point" [address]="location?.address"
                (pointEmitter)="point = $event"
                (addressEmitter)="location.address = $event">
              </sb-comp-address-component>

              <div class="wizard__footerActions">
                <button type="button" (click)="util.returnToNavigation(util.RoutingID.locations)"
                           class="btn btn-default btn-lg btn-wide">{{'lang.globals.cancel' | translate}}</button>
                <button type="button" (click)="updateLocationQuestion()"
                           [disabled]="!form.valid || !location.address?.country || (!(location.address?.position?.coordinates[0]) !== !(location.address?.position?.coordinates[1]))|| loading"
                           class="btn btn-success btn-wide btn-lg">{{'lang.globals.submit' | translate}}</button>
              </div>
            </form>
          </sb-wizard-tab>
          <div style="background-color: #f3f6f9;"
               class="wizard__aside wizard__aside--half wizard__aside--right p-0 flex-column">
            <div *ngIf="wizardState!=='Map'" class="w-100 d-flex px-4 pt-4 justify-content-end">
              <button (click)="changeWizardState('Map')" class="btn btn-hover-primary d-flex align-items-center">
                <sb-icon icon="cancel" class="icon-in-btn mr-1"></sb-icon>
                {{'lang.globals.closeFilterSelection' | translate}}
              </button>
            </div>


            <sb-page-companies class="w-100 p-4" *ngIf="wizardState==='CompanySelect'"
                               (selectedCompany)="selectCompany($event)"
                               [isInIntegratedContext]="true"></sb-page-companies>

            <sb-page-company-edit class="w-100 p-4" *ngIf="wizardState==='CompanyCreate'"
                                  (companyEmitter)="createCompany($event)"
                                  [isInIntegratedContext]="true"></sb-page-company-edit>

            <div *ngIf="wizardState==='Map'">
              <sb-map
                [drawing]="false"
                [mapHeight]="1061"
                [showSinglePoint]="point"
                (singlePointSelected)="point = $event"
                [selectSinglePoint]="true"
                [whatIsHere]="true"
              >
              </sb-map>
            </div>
          </div>
        </sb-wizard>
      </div>
    </sb-card>
  </div>
</div>
